var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduledEvent = function SvgScheduledEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.832 27.552"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.811 23.5H1.5a1 1 0 0 1-1-1v-19a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1V12M3.5.5V5M8.5.5V5M13.5.5V5M18.5.5V5",
    className: "scheduled-event_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 7.5-3 3L4 9M8.5 13l-3 3L4 14.5M10.5 9.5H17M10.5 14.5h3.164",
    className: "scheduled-event_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.332,
    cy: 21.052,
    r: 6,
    className: "scheduled-event_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.332 21.052h-2v-3",
    className: "scheduled-event_svg__st0"
  })))));
};
export default SvgScheduledEvent;